import { TableBody } from '@mui/material';
import React from 'react';

import ArtworkRow from './ArtworkRow';

const TableArtworkCollectorBody = ({ listArtwork, showTransfereeColumn = false }) => {
  return (
    <TableBody>
      {listArtwork.map((artwork) => (
        <ArtworkRow
          key={artwork?.list_row_key || artwork?.uuid || artwork?.id}
          artwork={artwork}
          showTransfereeColumn={showTransfereeColumn}
        />
      ))}
    </TableBody>
  );
};

export default TableArtworkCollectorBody;
